const styles = () => ({
  container: {
    maxWidth: '1020px',
    margin: '0 auto'
  },
  spinner: {
    margin: '80px auto'
  }
})

export default styles
